import { Button, Checkbox, Flex, Input, Link, Radio, RadioGroup, Stack, Text, useToast } from '@chakra-ui/react'
import { useState } from 'react'
// import { useParams } from 'react-router-dom'

// import { useNavigate } from 'react-router-dom'
import { appApi } from '../../../services/appApi'
// import { LayoutFull } from '../../Layouts/LayoutFull'
import { Container } from '../../Layouts/LayoutFullAnswer/styles'

export const EnviarPIVale: React.FC = () => {
  const [Nome, setNome] = useState('')
  const [Cargo, setCargo] = useState('')
  const [Turno, setTurno] = useState('')
  const [Genero, setGenero] = useState('0')
  const [Escolaridade, setEscolaridade] = useState(0)
  const [Formacao, setFormacao] = useState('')
  const [Aceite, setAceite] = useState(false)
  const [ExibirTermos, setExibirTermos] = useState(false)
  // const { jobId } = useParams<{ jobId: string }>()

  const toast = useToast()
  //  const navigate = useNavigate()

  const escolaridadeTipo = [

    'Ensino fundamental',
    'Ensino médio',
    'Ensino técnico cursando',
    'Ensino técnico completo',
    'Superior cursando',
    'Superior completo',
    'Pós graduação cursando',
    'Pós graduação completo'
  ]

  function enviarAvaliacao(): void {
    if (Nome.length < 5) {
      toast({
        title: 'Você deve informar seu nome completo',
        position: 'top-right',
        variant: 'left-accent',
        status: 'error',
        duration: 9000,
        isClosable: false
      })
      return
    }
    if (Cargo.length < 3) {
      toast({
        title: 'Você deve informar seu cargo',
        position: 'top-right',
        variant: 'left-accent',
        status: 'error',
        duration: 9000,
        isClosable: false
      })
      return
    }
    if (Turno.length < 3) {
      toast({
        title: 'Você deve informar seu turno',
        position: 'top-right',
        variant: 'left-accent',
        status: 'error',
        duration: 9000,
        isClosable: false
      })
      return
    }
    if (Escolaridade > 1 && Formacao.length < 3) {
      toast({
        title: 'Você deve informar sua formação',
        position: 'top-right',
        variant: 'left-accent',
        status: 'error',
        duration: 9000,
        isClosable: false
      })
      return
    }
    // if (!ValidarEmail(Email)) {
    //   toast({
    //     title: 'Digite um email válido',
    //     position: 'top-right',
    //     variant: 'left-accent',
    //     status: 'error',
    //     duration: 9000,
    //     isClosable: false
    //   })
    //   return
    // }

    // if (!ValidaCPF(CPF)) {
    //   toast({
    //     title: 'Digite um CPF válido',
    //     position: 'top-right',
    //     variant: 'left-accent',
    //     status: 'error',
    //     duration: 9000,
    //     isClosable: false
    //   })
    //   return
    // }
    toast({
      title: 'carregando sua avaliação',
      // description: `Em breve um e-mail será enviado a ${Nome} ${Email}`,
      position: 'top-right',
      variant: 'left-accent',
      status: 'success',
      duration: 12000,
      isClosable: false
    })

    appApi.post('AssessmentPI/Send/sv', { nome: Nome, email: '', cpf: '', genero: Genero, cargo: Cargo, turno: Turno, escolaridade: escolaridadeTipo[Escolaridade], formacao: Formacao })
      .then(res => {
        console.log(res.data)
        const { url } = res.data
        toast({
          title: 'carregando sua avaliação',
          // description: `Em breve um e-mail será enviado a ${Nome} ${Email}`,
          position: 'top-right',
          variant: 'left-accent',
          status: 'success',
          duration: 12000,
          isClosable: false
        })
        window.location.replace(url)
        //     navigate('/AssessmentPi/Dashboard')
      }).catch(err => {
        toast({
          title: 'Não foi possível carregar a avaliação',
          description: 'Tente novamente mais tarde',
          position: 'top-right',
          variant: 'left-accent',
          status: 'error',
          duration: 9000,
          isClosable: false
        })
        console.log(err)
        //   navigate('/AssessmentPi/Dashboard')
      })
  }

  return <Flex direction={'column'} bgColor='white' p='1rem'>
    <Flex direction={'row'} justifyContent='space-around' >
     <img height={'50px'} alt='Logo da empresa' src='https://sigah.blob.core.windows.net/assets/LogoVale.png' />
     {/* <img height='40px' alt='Logo da empresa' src='https://sigah.blob.core.windows.net/onboard/f99445d7-d98d-48ad-9cdb-a443a9f636a2.png' /> */}
    </Flex>

            <Container>
    <Flex width={'100%'} justifyContent='center'>

    <Flex width={'100%'} direction='column' bgColor='white' minHeight={'400px'} >
    <Text alignSelf={'center'} textAlign='center' fontWeight={'bold'} fontSize='2xl'>Bem vindo a etapa de mapeamento comportamental da Vale. </Text>
    <Flex alignSelf={'center'} gap={'1rem'} m={'1rem'} fontSize={'sm'} flexDirection={'column'} maxWidth={'40Rem'} color={'gray.600'}>

    <Text fontSize={'sm'} fontWeight='bold' alignSelf={'center'}>
      A Vale está sempre em busca de novas práticas, mecanismos e ferramentas para construir um ambiente cada vez mais seguro e assim alcançar excelência operacional diante disto, pretende testar uma nova ferramenta que promete entregar análises que nos permitirão obter resultados que levam à implementação de melhorias organizacionais a partir do resultado do perfil comportamental de cada um dos nossos empregados, de tal forma, que os programas de aprendizagem passam abarcar desenvolvimento comportamental além da capacitação técnica.
    </Text>
    <Text fontSize={'sm'} fontWeight='normal' alignSelf={'center'}>
    A Predictive Index, através deste formulário, coletará os seguintes dados pessoais: nome, cargo, turno, escolaridade, sexo e realizará uma avaliação do perfil comportamental do participante através das respostas voluntariamente fornecidas ao longo do questionário e disponibilizará uma devolutiva individualizada aos participantes.
    </Text>
    <Text fontSize={'sm'} fontWeight='normal' alignSelf={'center'}>
    Ao final do piloto a consultoria entregará à Vale o diagnóstico organizacional.
    </Text>
    <Text fontSize={'sm'} fontWeight='normal' alignSelf={'center'}>
    A proteção à privacidade e aos dados pessoais são valores da Vale, por isso, reafirmamos aqui esse compromisso. Para conhecer mais sobre esse valor e como protegemos seus dados pessoais, acesse a intranet através do link
    &nbsp;<small><strong><a target={'_blank'} href='https://globalvale.sharepoint.com/teams/int-inst/SitePages/Global/pt/como-nos-mantemos-seguros/Privacidade-de-dados-new.aspx'>https://globalvale.sharepoint.com/teams/int-inst/SitePages/Global/pt/como-nos-mantemos-seguros/Privacidade-de-dados-new.aspx</a></strong></small> e aproveite para ler o “Aviso Interno de Privacidade aos Empregados”.
    </Text>
    </Flex>

    <Flex mt='2rem' alignSelf={'center'} direction='column' >

    <Text fontWeight={'bold'}>Antes de iniciar precisamos de alguns dados:</Text>

    <Text mt='1rem' fontWeight='bold' mb={2}>Qual o seu nome?</Text>
    <Input
      isInvalid={Nome.length < 8}
      errorBorderColor='red.300'
    onChange={(s) => setNome(s.target.value)} placeholder='Digite o seu nome' />

    <Text mt='1rem' fontWeight='bold' mb={2}>Qual o seu Cargo?</Text>
    <Input width={'25rem'}
          isInvalid={Cargo.length < 3 }
          errorBorderColor='red.300'
    onChange={(s) => setCargo(s.target.value) } value={Cargo} placeholder='Digite o seu Cargo' />
    <Text mt='1rem' fontWeight='bold' mb={2}>Qual o seu turno?</Text>
     <RadioGroup onChange={ (e) => setTurno(e)} value={Turno}>
      <Stack direction='column'>
        <Radio value='A97'>A97</Radio>
        <Radio value='A98'>A98</Radio>
        <Radio value='A99'>A99</Radio>
        <Radio value='ADM'>ADM</Radio>
        <Radio value='B97'>B97</Radio>
        <Radio value='B99'>B99</Radio>
      </Stack>
    </RadioGroup>

    <Text mt='1rem' fontWeight='bold' mb={2}>Qual a sua escolaridade?</Text>
     <RadioGroup onChange={ (e) => setEscolaridade(Number.parseInt(e))} value={Escolaridade}>
      <Stack direction='column'>
        <Radio value={0}>Ensino fundamental</Radio>
        <Radio value={1}>Ensino médio</Radio>
        <Radio value={2}>Ensino técnico cursando</Radio>
        <Radio value={3}>Ensino técnico completo</Radio>
        <Radio value={4}>Superior cursando</Radio>
        <Radio value={5}>Superior completo</Radio>
        <Radio value={6}>Pós graduação cursando</Radio>
        <Radio value={7}>Pós graduação completo</Radio>
      </Stack>
    </RadioGroup>
    {Escolaridade > 1 && <>
    <Text mt='1rem' fontWeight='bold' mb={2}>Qual a sua formação?</Text>
    <Input width={'25rem'}
          isInvalid={(Escolaridade > 1 && Formacao.length < 3) }
          errorBorderColor='red.300'
          onChange={(s) => setFormacao(s.target.value) } value={Formacao} placeholder='Digite o curso realizado' />
          </>
}
    <Text mt='1rem' fontWeight='bold' mb={2}>Qual o seu sexo?</Text>
     <RadioGroup onChange={ (e) => setGenero(e)} value={Genero}>
      <Stack direction='row'>
        <Radio value='2'>Feminino</Radio>
        <Radio value='1'>Masculino</Radio>
      </Stack>
    </RadioGroup>

    <Text mt='1rem' fontWeight='bold' mb={2}>Para continuar você deve aceitar os termos de uso e privacidade <Link color='blue.600' onClick={() => setExibirTermos(!ExibirTermos)}>disponíveis aqui para consulta.</Link></Text>
    {ExibirTermos &&
    <Flex border={'1px'} p='1rem' h={'10rem'} overflow={'scroll'}>

      <section aria-labelledby="termo-privacidade-titulo">
        <h2 id="termo-privacidade-titulo">Termo de Privacidade e Tratamento de Dados</h2>

        <p>Ao prosseguir, você declara estar ciente e de acordo com o tratamento
          dos seus dados pessoais para a realização do mapeamento de perfil comportamental.</p>
        <p>&nbsp;</p>

        <h3>Dados coletados</h3>
        <ul>
          <li>
            <strong>Nome</strong>, <strong>cargo</strong>, <strong>turno</strong>, <strong>escolaridade</strong> e <strong>sexo</strong>.
          </li>
        </ul>
        <p>&nbsp;</p>
        <h3>Finalidades e responsáveis pelo tratamento</h3>
        <ul>
          <li>A <strong>Predictive Index</strong> tratará <strong>apenas</strong> os dados de  <strong>Nome</strong> para identificação e <strong>sexo</strong> apenas para ajustes de concordância para o relatório em português.</li>
          {/* <li>A <strong>Arquitetura Humana</strong> utilizará os dados informados para gestão do processo e consolidação dos resultados.</li> */}
          <li>Os resultados do mapeamento serão compartilhados com a <strong>Vale</strong> exclusivamente para fins de desenvolvimento comportamental e organizacional.</li>
        </ul>

        <p>&nbsp;</p>

        <h3>Segurança e retenção</h3>
        <p>As informações serão utilizadas somente para as finalidades acima,
          armazenadas de forma segura e mantidas pelo tempo necessário à condução do processo.</p>

        <p>&nbsp;</p>
        <p><strong>Ao aceitar este termo, você consente expressamente com o tratamento dos seus dados pessoais conforme descrito.</strong></p>
      </section>

    </Flex>
}
    <Checkbox my='1rem'
        isChecked={Aceite}
        onChange={(e) => setAceite(e.target.checked)}
      >
        Estou ciente com os termos de uso
      </Checkbox>

    </Flex>
    <Flex gap={'1rem'} mt='3rem'>
    <Button isDisabled={!Aceite} width={'100%'} bgColor={'var(--Rosa)'}
    onClick={enviarAvaliacao}
    >Iniciar o teste</Button>

    </Flex>

    </Flex>
    </Flex>

            </Container>
    </Flex>
}
